import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CuentasService, DialogsService, SpinnerService} from '../../../../services';
import {Router} from '@angular/router';
import {MdDialog, MdDialogConfig, MdDialogRef, MdSnackBar} from '@angular/material';
import {Subscription} from 'rxjs/Subscription';
import {ChipFilterItem, FilterSettings, FilterType, GenericTableDataSource} from '../../../common';
import {BuildUsuarioAgroChips, GetAgroFilterFromColumns, TableColumnData, UsuarioAgro} from '../usuarios.component';
import {PATH_DETALLE_USUARIO_AGRO, PATH_EDITAR_USUARIO_AGRO} from '../../../../navigation/navigation.module';
import { CuitPipe } from '../../../../utils';
import {AcoCuitDialogComponent} from '../aco-cuit-dialog';

@Component({
  selector: 'app-usuario-agro-pendientes',
  templateUrl: './usuario-agro-pendientes.component.html',
  styleUrls: ['./usuario-agro-pendientes.component.scss'],
  providers: [CuitPipe]
})
export class UsuarioAgroPendientesComponent implements OnInit, OnDestroy {

  firstLoad = false;

  agroResponseData = [];

  agroTableWidth = '500px';

  cargando = false;
  sub: Subscription;

  pendientesChips: ChipFilterItem[] = [];

  orderTimeout = null;

  // paginador
  paginadorMarginLeft = '0px'
  pageSize = 10;
  currentPage = 0;
  resultsFullCount = 0;
  resultsPageCount = 0;


  @ViewChild('cardTable', { read: ElementRef }) table: ElementRef;
  @ViewChild('topScroller') topScroller: ElementRef;

  @Output() onChipsListChanged = new EventEmitter();
  @Output() onHistorialReload = new EventEmitter();

  // el orden en este objeto delimita el orden de columnas
  columnsDataSource: TableColumnData[] = [
    { column: 'accion', title: 'Acción', width: '170px', order: null, filter: null, filterType: '', filterPropertyName: '', sortable: false},
    { column: 'usuario', title: 'Usuario', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Usuario', sortable: true },
    { column: 'email', title: 'Email', width: '250px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Mail', sortable: true },
    { column: 'nombre', title: 'Nombre', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Nombre', sortable: true },
    { column: 'apellido', title: 'Apellido', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Apellido', sortable: true },
    { column: 'cuitRazon', title: 'Empresa', width: '275px', order: null, filter: null, filterType: FilterType.cuitRazon, filterPropertyName: '', sortable: true },
    { column: 'acopios', title: 'Acopios', width: '200px', order: null, filter: null, filterType: FilterType.rol, filterPropertyName: 'Acopios', sortable: true },
    { column: 'fechaCreac', title: 'Fecha de Creación', width: '170px', order: false, filter: null, filterType: FilterType.dateRange, filterPropertyName: 'MiembroDesde', sortable: true },
  ];

  constructor(
    private cuentasService: CuentasService,
    private router: Router,
    private dialogsService: DialogsService,
    private spinnerService: SpinnerService,
    private snackBar: MdSnackBar,
    private cuitPipe: CuitPipe,
    private dialog: MdDialog,
  ) {
    this.sub = spinnerService.showSoftFlag$.subscribe(x => {
      this.cargando = x;
    })
    this.getUsuariosAgro();
  }

  ngOnInit() {
    this.agroTableWidth = this.columnsDataSource.map(x => parseInt(x.width.slice(0, -2), 10)).reduce((a, b) => a + b).toString() + 'px';
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getUsuariosAgro() {
    let payload = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      ColumnOrder: this.columnsDataSource.find(x => x.order !== null).column,
      AscendingOrder: this.columnsDataSource.find(x => x.order !== null).order,
      EstadosId: [2],
    };
    payload = {...payload, ...GetAgroFilterFromColumns(this.columnsDataSource)}
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.cuentasService.getAgroUsersPending(payload).subscribe(x => {
      this.agroResponseData = x;
      this.resultsFullCount = this.agroResponseData.length ? x[0].Total : 0;
      this.resultsPageCount = this.agroResponseData.length ? Math.ceil(x[0].Total / this.pageSize) : 0;
      this.spinnerService.setSoftSpinnerShowFlag(false);
    }, err => this.spinnerService.setSoftSpinnerShowFlag(false));
  }

  onUsuarioAction(action, user: UsuarioAgro) {
    switch (action) {
      case 'A':
        this.dialogsService.confirm('¿Desea Activar este Usuario?', '', 'SÍ, ACEPTAR', 'NO, CANCELAR').subscribe( res => {
          if (res) {
            const payload = {
              UserId: user.ID,
              Status: 2,
              Nombre: user.Nombre,
              Apellido: user.Apellido,
              Detalle: ''
            };
            this.cuentasService.agroUserValidate(payload).subscribe(_ => {
              this.onHistorialReload.emit();
              this.getUsuariosAgro();
              this.snackBar.open('Usuario activado correctamente.', '', {
                duration: 2000,
              });
            }, err => {
              this.snackBar.open('Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.', '', {
                duration: 2000,
                extraClasses: ['agd-warning-snackbar']
              });
            });
          }});
        break;

      case 'R':
        this.dialogsService.showTextAreaDialog('¿Desea Rechazar este Usuario?', '', 'SÍ, RECHAZAR', 'NO, CANCELAR', true, 300)
          .subscribe(res => {
            if (res.length) {
              const payload = {
                UserId: user.ID,
                Status: 3,
                Nombre: user.Nombre,
                Apellido: user.Apellido,
                Detalle: res.trim()
              };
              this.cuentasService.agroUserValidate(payload).subscribe(_ => {
                this.getUsuariosAgro();
              });
            }
          });
        break;

      case 'D':
        this.dialogsService.showTextAreaDialog('¿Desea Desconocer este Usuario?', '', 'SÍ, DESCONOCER', 'NO, CANCELAR', true, 300)
          .subscribe(res => {
            if (res.length) {
              const payload = {
                UserId: user.ID,
                Status: 4,
                Nombre: user.Nombre,
                Apellido: user.Apellido,
                Detalle: res.trim()
              };
              this.cuentasService.agroUserValidate(payload).subscribe(_ => {
                this.onHistorialReload.emit();
                this.getUsuariosAgro();
                this.snackBar.open('Usuario desconocido correctamente.', '', {
                  duration: 2000,
                });
              }, err => {
                this.snackBar.open('Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.', '', {
                  duration: 2000,
                  extraClasses: ['agd-warning-snackbar']
                });
              });
            }
          });
        break;

      case 'I':
        const data = user.Acopios ? user.Acopios.map(x => x.RolName) : [];
        let dialogRef: MdDialogRef<AcoCuitDialogComponent>;
        const config = new MdDialogConfig();
        config.width = '500px';
        dialogRef = this.dialog.open(AcoCuitDialogComponent, config);
        dialogRef.componentInstance.title = 'Acopios';
        dialogRef.componentInstance.data = data;
        break;

      case 'E':

        break;
    }
  }

  onScroll(e, item) {
    if (item === 'main') {
      this.table.nativeElement.scrollLeft = e.target.scrollLeft;
    } else if (item === 'table') {
      this.topScroller.nativeElement.scrollLeft = e.target.scrollLeft;
    }
    this.paginadorMarginLeft = e.target.scrollLeft + 'px';
  }

  openFilter(col: TableColumnData) {
    clearTimeout(this.orderTimeout);
    if (col.filterType === '') { return; }
    const settings: FilterSettings = {
      FilterTitle: col.title,
      FilterName: col.column,
      FilterPlaceholder: col.title,
      FilterType: col.filterType,
    };
    if (col.column === 'estado') {
      settings.PreviousChipList = [{ID: 1, ItemLabel: 'Activo'}, {ID: 1, ItemLabel: 'Inactivo'}];
    }
    // si existe el filtro, lo cargamos
    if (col.filter !== null) {
      switch (col.filterType) {
        case FilterType.string:
          settings.PreviousString = col.filter['MinValue'];
          break;
        case FilterType.colaborador:
        case FilterType.acopio:
          settings.PreviousChipList = col.filter['MinValue'];
          break;
        case FilterType.dateRange:
          settings.PreviousNumberMin = col.filter['MinValue'];
          settings.PreviousNumberMax = col.filter['MaxValue'];
          break;
        case FilterType.chip:
          settings.PreviousArrayNum = col.filter['MinValue'].map(x => x.ID);
          break;
        case FilterType.cuitRazon:
          settings.PreviousString = col.filter['MinValue'];
          settings.PreviousNumberMin = col.filter['MaxValue'];
          break;
        case FilterType.rol:
          settings.PreviousArrayNum = col.filter['MinValue'];
      }
    }
    const sub = this.dialogsService.showGenericFilterDialog(settings).subscribe(res => {
      if (res) {
        col.filter = res.MinValue === null && res.MaxValue === null ? null : {MinValue: res.MinValue, MaxValue: res.MaxValue };
        this.buildChips();
        this.getUsuariosAgro();
      }
      sub.unsubscribe();
    });
  }

  buildChips(): void {
    this.pendientesChips = BuildUsuarioAgroChips(this.columnsDataSource);
    this.onChipsListChanged.emit();
  }

  changeOrder(col: TableColumnData) {
    clearTimeout(this.orderTimeout);
    if (!col.sortable) { return; }
    this.orderTimeout = setTimeout(() => {
      if (col.order === null) {
        this.columnsDataSource.forEach(x => x.order = null);
        col.order = true;
      } else {
        col.order = !col.order;
      }
      this.getUsuariosAgro();
      this.orderTimeout = null;
    }, 250);
  }

  resetFilters(): void {
    this.columnsDataSource.forEach(x => {
      x.filter = null;
    })
    this.buildChips();
    this.getUsuariosAgro();
  }

  removeFilter(chip: ChipFilterItem): void {
    this.columnsDataSource.find(x => x.column === chip.Id).filter = null;
    this.pendientesChips.splice(this.pendientesChips.findIndex(x => x.Id === chip.Id), 1);
    this.onChipsListChanged.emit();
    this.getUsuariosAgro();
  }

  showCuitDetail(row): void {
    const data = row.Cuits ? row.Cuits.map(x => this.cuitPipe.transform(x.Cuit, '') + ' / ' + x.RazonSocial) : []
    let dialogRef: MdDialogRef<AcoCuitDialogComponent>;
    const config = new MdDialogConfig();
    config.width = '500px';
    dialogRef = this.dialog.open(AcoCuitDialogComponent, config);
    dialogRef.componentInstance.title = 'Cuit/Razón Social';
    dialogRef.componentInstance.data = data;
  }

  showEditUsuarioDialog(row): void {
    this.router.navigate([PATH_EDITAR_USUARIO_AGRO, row.ID]);
  }

  showUserData(row): void {
    this.router.navigate([PATH_DETALLE_USUARIO_AGRO, row.ID]);
  }

  onGoToPage(next: boolean): void {
    if (this.cargando) {return;}
    if (next) {
      if (this.currentPage < this.resultsPageCount - 1) {
        // avanzar pagina
        this.currentPage++;
        this.getUsuariosAgro();
      }
    } else {
      if (this.currentPage > 0) {
        // retroceder pagina
        this.currentPage--;
        this.getUsuariosAgro();
      }
    }
  }

  changePageSize(e): void {
    this.currentPage = 0;
    this.getUsuariosAgro();
  }

  getMaxWidthPaginador(): string {
    return (Number(this.agroTableWidth.replace('px', '')) - 20).toString() + 'px';
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-pendientes/usuario-agro-pendientes.component.ts